module.exports = __webpack_public_path__ + "img/4041.96adf604.png";